import CheckWallet from "./CheckWallet";

export default CheckWallet;